import React from 'react'
      
const Contact = () => {
  return (
    <div className='mt-[100px] mb-[100px]'>
      Contact
          </div>
  )
}

export default Contact